module.exports = __webpack_public_path__ + "img/Artboard 1_800.7e894667.jpg";